"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var PromotionalPricing_1 = require("./PromotionalPricing");
exports.default = PromotionalPricing_1.default;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/duc/components/containers/PromotionalPricing/index.js
// module id = 1849
// module chunks = 8